import {PortableText, type PortableTextComponents} from '@portabletext/react'
import type {PortableTextBlock} from '@portabletext/react'
import {urlForImage} from '@/lib/sanity'
import type {SanityImageReference} from '@/types/blog'

const components: PortableTextComponents = {
  types: {
    image: ({value}: {value: SanityImageReference & {alt?: string; caption?: string}}) => {
      if (!value?.asset) return null
      const src = urlForImage(value).width(1200).fit('max').auto('format').url()
      return (
        <figure className="my-6">
          <img
            src={src}
            alt={value.alt ?? ''}
            loading="lazy"
            className="rounded-lg w-full h-auto"
          />
          {value.caption ? (
            <figcaption className="text-sm text-muted-foreground mt-2 text-center">
              {value.caption}
            </figcaption>
          ) : null}
        </figure>
      )
    },
  },
  marks: {
    link: ({value, children}) => {
      const href = (value?.href as string | undefined) ?? '#'
      const newTab = Boolean(value?.newTab)
      return (
        <a
          href={href}
          target={newTab ? '_blank' : undefined}
          rel={newTab ? 'noopener noreferrer' : undefined}
          className="underline underline-offset-2 hover:text-foreground"
        >
          {children}
        </a>
      )
    },
  },
}

interface Props {
  value: PortableTextBlock[]
}

const PortableTextRenderer = ({value}: Props) => (
  <div className="prose prose-lg max-w-none text-foreground prose-headings:font-display prose-headings:text-foreground prose-p:text-foreground prose-strong:text-foreground prose-a:text-foreground prose-blockquote:text-muted-foreground prose-blockquote:border-l-foreground/30">
    <PortableText value={value} components={components} />
  </div>
)

export default PortableTextRenderer
